<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Printing/Cutting
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Overview</a>
          <ul>
            <li @click="activeMenuLink = 'offshore-print/overview'"><router-link to="/offshore-print/overview"  :class="{'is-active':activeMenuLink === 'offshore-print/overview'}">Overview</router-link></li>
             <li @click="activeMenuLink = 'offshore-print/overviewreport'" style=""><router-link to="/offshore-print/overviewreport"  :class="{'is-active':activeMenuLink === 'offshore-print/overviewreport'}">Overview (New Demo)</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/view-order'" v-if="1==2"><router-link to="/printing-cutting/view-order"  :class="{'is-active':activeMenuLink === 'printing-cutting/view-order'}">Find an Order</router-link></li>
            <li @click="activeMenuLink = 'printing-cutting/scheduler'"  v-if="1==2"><router-link to="/printing-cutting/scheduler"  :class="{'is-active':activeMenuLink === 'printing-cutting/scheduler'}">Scheduler</router-link></li>
            <li @click="activeMenuLink = 'offshore/planner'"  ><router-link to="/offshore/planner"  :class="{'is-active':activeMenuLink === 'offshore/planner'}">Print Planner</router-link></li>
            
          </ul>
        </li>
        <li>
          <a class="">Areas</a>
          <ul>
            <li @click="activeMenuLink = 'offshore-print/printing-paper'"><router-link to="/offshore-print/printing-paper"  :class="{'is-active':activeMenuLink === 'offshore-print/printing-paper'}">Printing Paper</router-link></li>
            <li @click="activeMenuLink = 'offshore-print/printing-rolls'"><router-link to="/offshore-print/printing-rolls"  :class="{'is-active':activeMenuLink === 'offshore-print/printing-rolls'}">Printing Rolls (Trans)</router-link></li>
            <li @click="activeMenuLink = 'offshore-print/cutting'"><router-link to="/offshore-print/cutting"  :class="{'is-active':activeMenuLink === 'offshore-print/cutting'}">Cutting (Gerber)</router-link></li>
            <li @click="activeMenuLink = 'offshore-print/multiply-cutting'" ><router-link to="/offshore-print/multiply-cutting"  :class="{'is-active':activeMenuLink === 'offshore-print/multiply-cutting'}">Cutting (Multi-Ply)</router-link></li>
            <li @click="activeMenuLink = 'offshore-print/awaiting-makeup'"><router-link to="/offshore-print/awaiting-makeup"  :class="{'is-active':activeMenuLink ==='offshore-print/awaiting-makeup'}">Awaiting Makeup</router-link></li>
            <li @click="activeMenuLink = 'offshore-print/multiply-awaiting-makeup'"  v-if="1==2"><router-link to="/offshore-print/multiply-awaiting-makeup"  :class="{'is-active':activeMenuLink === 'offshore-print/multiply-awaiting-makeup'}">Multi-Ply Awaiting Makeup</router-link></li>
            
          </ul>
        </li>

        <li  >
          <a class="">Reports</a>
          <ul>
            <li @click="activeMenuLink = 'offshore-print/printing-cutting-summary'"><router-link to="/offshore-print/printing-cutting-summary"  :class="{'is-active':activeMenuLink === 'offshore-print/printing-cutting-summary'}">Summary Report</router-link></li>
            <li @click="activeMenuLink = 'offshore-print/printing-processed-report'"><router-link to="/offshore-print/printing-processed-report"  :class="{'is-active':activeMenuLink === 'offshore-print/printing-processed-report'}">Processed Report</router-link></li>
             
          </ul>
        </li>
        
        <li>
          <a class="">Data Input</a>
          <ul>
            <li @click="activeMenuLink = 'printing-cutting/data-input'"><router-link to="/printing-cutting/data-input"  :class="{'is-active':activeMenuLink === 'printing-cutting/data-input'}">Factory Floor</router-link></li>
            
          </ul>
        </li>
        
        
      </ul>

      
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarPrintingCutting',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    this.activeMenuLink = this.$route.path.substring(1)
    console.log(this.$route.path)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks
        });
	}
}

</script>



